// Shared by the expanded roll row and the full roll details.
export default {
  computed: {
    columns () {
      return [
        { title: '工人', minWidth: 150, render: (h, { row }) => h('div', [h('strong', this.workerName(row)), h('div', { style: { color: '#808695' } }, row.workerId ? [row.workerType === 'INTERNAL' ? '内部工人' : '第三方工人', row.workerNo].filter(Boolean).join(' · ') : '圈数与瑕疵正常记录')]) },
        { title: '圈数范围', minWidth: 155, render: (h, { row }) => h('span', this.range(row)) },
        { title: '本段圈数', key: 'roundCount', minWidth: 100 },
        { title: '状态', width: 100, render: (h, { row }) => h('Tag', { props: { color: row.status === 'ACTIVE' ? 'blue' : 'default' } }, this.statusName(row.status)) },
        { title: '开始时间', minWidth: 175, render: (h, { row }) => h('span', this.time(row.startedAt)) },
        { title: '结束时间', minWidth: 175, render: (h, { row }) => h('span', row.endedAt ? this.time(row.endedAt) : row.status === 'ACTIVE' ? '尚未结束' : '—') },
        { title: '已上传瑕疵', key: 'uploadedDefectCount', minWidth: 115 }
      ]
    }
  },
  methods: {
    statusName (status) { return ({ READY: '待生产', ACTIVE: '生产中', FINISHED: '已完成', CLOSED: '已结束' })[status] || status || '—' },
    workerName (row) { return row.workerId ? (row.workerName || '未知工人') : '未分配人员' },
    range (row) { return row.firstRound === null || row.firstRound === undefined || row.lastRound === null || row.lastRound === undefined ? '暂无生产圈数' : `第 ${row.firstRound}～${row.lastRound} 圈` },
    time (value) {
      if (!value) return '—'
      const date = new Date(value)
      return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai', hour12: false })
    }
  }
}
